import React from 'react';
import PropTypes from 'prop-types';
import SequenceSelectAction from '../actions/SequenceSelectAction';
import ChannelSequenceItem from './ChannelSequenceItem';

export default class ChannelSequenceList extends React.Component {

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  handleClickSequence(key) {
    this.context.executeAction(SequenceSelectAction, {
      channel: this.props.number,
      sequence: key
    });
  }

  render() {

    var sequences = this.props.sequences.map((sequence, i) => {
      return (
        <ChannelSequenceItem sequence={sequence} key={i} selected={this.props.selected}/>
      );
    });

    return (
      <ul>
        {sequences}
      </ul>
    );
  }
}
